import { showSuccessNotify } from "../../utils/Notiffication";
import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/market/wb'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class MarketWbApi {

    static async loadCards({ data = { shop: undefined, offerId: undefined, onlyNew: undefined }, ...params }) {
        return await fetchService({ url: '/loadcards', method: 'POST', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }

    static async calculateCommission({ data = { shop: undefined, onlyNew: undefined }, ...params }) {
        return await fetchService({ url: '/loadprices', method: 'POST', data, ...params })
    }

    static async loadCategories({ data = undefined, ...params }) {
        return await fetchService({ url: '/loadcategories', method: 'GET', data, ...params })
    }

    static async loadBasketedCards({ data = { shop: undefined }, ...params }) {
        return await fetchService({ url: '/loadcardsbasket', method: 'POST', data, ...params })
    }

    static async loadWarehouseStocks({ data = { shop: undefined }, ...params }) {
        return await fetchService({ url: '/loadwarehousestocks', method: 'POST', data, ...params })
    }

    static async uploadImages({ data = { shop: undefined, offerIds: 'Array' }, ...params }) {
        return await fetchService({ url: '/uploadimages', method: 'POST', data, ...params })
    }



    static async getCardsBySearch({ data = { shop: undefined, search: undefined, tab: undefined, providerId: undefined, filters: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/getcards', method: 'POST', data, notify: { success: false }, ...params })
    }


    static async getCategories({ data = { search: undefined }, ...params }) {
        return await fetchService({ url: '/getcategories', method: 'GET', data, notify: { success: false }, ...params })
    }

    static async changeCard({ data = { shop: undefined, offer_id: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changecard', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    // static async deleteCards({ data = { shop: undefined, offerIds: undefined }, ...params }) {
    //     return await fetchService({ url: '/deletecards', method: 'POST', data, ...params })
    // }

    static async updateByExcel({ data = { shop: undefined, file: undefined }, ...params }) {
        return await fetchService({ url: '/updatebyexcel', method: 'POST', data, ...params })
    }

    static async uploadStocksAndPrices({ data = { shop: undefined, file: undefined }, ...params }) {
        return await fetchService({ url: '/uploadstocksandprices', method: 'POST', data, ...params })
    }

    static async excelStocksAndPricesTmp({ data = { shop: undefined }, ...params }) {
        return await fetchService({ url: '/exceltocksandpricestmp', method: 'POST', data, options: { download: true }, ...params })
    }

    static async updateStocks({ data = { shop: undefined, filter: undefined, rules: undefined, skladName: undefined, waitEnd: undefined }, ...params }) {
        return await fetchService({ url: '/updatestocks', method: 'POST', data, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }

    static async updatePrices({ data = { shop: undefined, filter: undefined, rules: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/updateprices', method: 'POST', data, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }




    static async changeMarginality({ data = { shop: undefined, offer_id: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changemarginality', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    static async changePrice({ data = { shop: undefined, offer_id: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changeprice', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    static async changeStock({ data = { shop: undefined, offer_id: undefined, value: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/changestock', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    // static async deleteSales({ data = { shop: undefined, offerIds: undefined }, ...params }) {
    //     return await fetchService({ url: '/deletesales', method: 'PATCH', data, ...params })
    //         .then(r => { showSuccessNotify(`Изменения для ${offer_id} сохранены`); return r })
    // }

    static async changeBasket({ data = { shop: undefined, offerIds: undefined, value: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/changebasket', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }

    static async changeStopBrand({ data = { shop: undefined, offerIds: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changestopbrand', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }

    static async loadAiImage({ data = { shop: undefined, offerIds: undefined }, ...params }) {
        return await fetchService({ url: '/loadaiimage', method: 'POST', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }


    static async excelAnalytics({ data = { shop: undefined, search: undefined, tab: undefined, filters: undefined, providerId: undefined }, ...params }) {
        return await fetchService({ url: '/excelanalitycs', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelData({ data = { shop: undefined, search: undefined, tab: undefined, filters: undefined, providerId: undefined }, ...params }) {
        return await fetchService({ url: '/exceldata', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelStocksFbsActive({ data = { shop: undefined, search: undefined, tab: undefined, filters: undefined, providerId: undefined }, ...params }) {
        return await fetchService({ url: '/excelstocksfbsactive', method: 'POST', data, options: { download: true }, ...params })
    }


    // static async excelImagesByExcel({ data = { shop: undefined, file: undefined }, ...params }) {
    //     return await fetchService({ url: '/excelimages', method: 'POST', data, options: { download: true }, ...params })
    // }


    static async fboSticker({ data = { offerId: undefined, shop: undefined }, ...params }) {
        return await fetchService({ url: '/fbosticker', method: 'POST', data, options: { pdf: true }, ...params })
    }

}